import type { BackendPaginationMeta } from 'src/components/ServerPaginatedTable/types';
import { DEFAULT_PAGINATION_META } from 'src/components/ServerPaginatedTable/constants';
import { StaffContactRecord, StaffContactSortField } from '../services/staff-contacts/types';

export interface StaffContactsState {
  contacts: StaffContactRecord[];
  loading: boolean;
  hasLoaded: boolean;
  saving: boolean;
  error: string | null;
  pagination: BackendPaginationMeta;
  sortBy: StaffContactSortField;
  sortDirection: 'asc' | 'desc';
}

export const initialState: StaffContactsState = {
  contacts: [],
  loading: false,
  hasLoaded: false,
  saving: false,
  error: null,
  pagination: DEFAULT_PAGINATION_META,
  sortBy: 'createdAt',
  sortDirection: 'desc',
};
